"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTradingDay = IsTradingDay;
const date_1 = require("./date");
const holidays_1 = require("./holidays");
function IsTradingDay(date) {
    const result = {
        is_trading_day: false,
        is_half_day: false,
    };
    if (date.dayOfWeek() === date_1.DayOfWeek.SATURDAY || date.dayOfWeek() == date_1.DayOfWeek.SUNDAY) {
        return result;
    }
    if ((0, holidays_1.IsHoliday)(date)) {
        return result;
    }
    result.is_trading_day = true;
    // Check 3 trading half days
    for (let i = 0; i < 3; i++) {
        if ((0, holidays_1.TradingHalfDay)(i, date.year).eq(date)) {
            result.is_half_day = true;
        }
    }
    return result;
}
